import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import clsx from "clsx";
import rowStyles from "./rowStyles.less";

export const getQColumns = (
  t: TFunction,
  options: string[],
  optionChildren: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`q.${option}`),
      dataIndex: option,
      key: option,
      align: (option !== "KPI" ? "center" : "left") as "left" | "center",
      onCell: (record: any) => {
        // Определяем фон ячейки на основе квартиля
        let backgroundColor = "";

        if (options.includes("button")) {
          if (record.type === "header") {
            // Для строк-заголовков
            backgroundColor = record.ParentId !== null ? "#E7E8EA" : "#FBC78E";
          } else if (optionChildren.includes(option)) {
            // Для обычных строк с цветовыми опциями - по квартилю
            const quartile = record.GroupIndicatorId?.trim();
            if (quartile === "I") backgroundColor = "#B2D363";
            else if (quartile === "II") backgroundColor = "#FFDE5A";
            else if (quartile === "III") backgroundColor = "#FA9863";
            else if (quartile === "IV") backgroundColor = "#FF747C";
          }
        }

        return {
          style: {
            backgroundColor,
            height: record.type === "header" ? "27px" : "39px",
          },
        };
      },
    };

    // Для кнопки View в первой колонке
    if (option === "button") {
      return {
        ...baseColumn,
        title: "",
        width: 100,
        render: (_: any, record: any) =>
          record.type === "header" ? null : (
            <div className={rowStyles.cont}>{record.button}</div>
          ),
      };
    }

    // Для колонок с подписями периодов снизу
    if (optionChildren.includes(option)) {
      return {
        ...baseColumn,
        render: (value: any, record: any) => {
          // Для заголовков в цветовых колонках не показываем контент
          if (record.type === "header") {
            return null;
          }

          return (
            <div>
              <div className={rowStyles.cont}>{value}</div>
              {record[option + "Period"] && (
                <div className={rowStyles.cont_under}>
                  {record[option + "Period"]}
                </div>
              )}
            </div>
          );
        },
      };
    }

    // Для колонки KPI делаем жирный шрифт и выравнивание слева
    if (option === "KPI") {
      return {
        ...baseColumn,
        width: 500,
        render: (value: any) => (
          <div className={rowStyles.kpi_text}>{value}</div>
        ),
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
